<div class="onboarding">
  <div class="onboarding__content">
    <div class="onboarding__header">
      <h2 class="onboarding__title">{{ 'onboardingSlides.title' | translate }}</h2>
      <button class="onboarding__close" (click)="closeModal(OnboardingStatus.uncompleted)">
        <app-icon class="icon-close" [icon]="IconName.CLOSE" />
      </button>
    </div>

    <img
      class="onboarding__img"
      [src]="slides()[currentSlide()].imageUrl | translate"
      alt="slide-img"
    />
    <p class="onboarding__subtitle">{{ slides()[currentSlide()].subtitle | translate }}</p>
    <p class="onboarding__description">{{ slides()[currentSlide()].description | translate }}</p>
    <div class="onboarding__footer">
      <div class="onboarding__dots">
        @for (slide of slides(); track slide) {
          <div class="onboarding__dot" [class.filled]="slide === slides()[currentSlide()]"></div>
        }
      </div>
      <div class="onboarding__buttons">
        @if (currentSlide() === 0) {
          <button class="onboarding__button" (click)="closeModal(OnboardingStatus.completed)">
            {{ 'onboardingSlides.closeButton' | translate }}
          </button>
          <button class="btn-primary" (click)="nextSlide()">
            {{ 'onboardingSlides.nextButton' | translate }}
          </button>
        } @else {
          <button class="onboarding__button" (click)="prevSlide()">
            {{ 'onboardingSlides.prevButton' | translate }}
          </button>
          <button class="btn-primary" (click)="closeModal(OnboardingStatus.completed)">
            {{ 'onboardingSlides.getStartedButton' | translate }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
